'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { User } from 'lucide-react';

export function UserAccountButton() {
  const tCommon = useTranslations('common');
  const pathname = usePathname();
  const isAccountActive =
    pathname === '/account' || pathname.startsWith('/account/');

  return (
    <Link
      href="/account"
      className={`flex items-center justify-center w-8 h-8 lg:w-10 lg:h-10 rounded-full transition-colors ${
        isAccountActive
          ? 'bg-muted text-foreground'
          : 'text-muted-foreground hover:text-foreground hover:bg-muted'
      }`}
      title={tCommon('accountSettings')}
    >
      <User className="h-4 w-4 lg:h-6 lg:w-6" />
    </Link>
  );
}
